import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { BuildQueryProps } from 'utils/QueryHelpers'

import { TickmillCompanyAllowedReferralsDtoKey } from '../../../../api/Trading-Accounts/Types/TickmillCompanyAllowedReferralsDto'

export const normalizeReferralsRestrictionsPageSearchQuery = (
  filterDescriptor: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filterDescriptor as CompositeFilterDescriptor
  const filters =
    gridFilterDescriptor?.filters.map((x: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = x as FilterDescriptor
      if (filterItem.field === TickmillCompanyAllowedReferralsDtoKey.tickmillCompany) {
        return {
          ...filterItem,
          field: 'TickmillCompany',
          value: filterItem?.value,
        }
      }
      if (filterItem.field === TickmillCompanyAllowedReferralsDtoKey.allowedTickmillCompany) {
        return {
          ...filterItem,
          field: 'AllowedTickmillCompany',
          value: filterItem?.value,
        }
      }
      return filterItem
    }) || []

  return { ...gridFilterDescriptor, filters }
}
